export const isStatusEnabled = (status, filterStatus) => {
  if (!status || !filterStatus) {
    return false;
  }
  if (status === "approved") {
    return filterStatus.approved === 1;
  }
  if (status === "notApproved") {
    return filterStatus.notApproved === 1;
  }
  if (status === "withdraw") {
    return filterStatus.withdraw === 1;
  }
  return false;
};

export const classifyRequestTimeStatus = (row) => {
  if (row.isActive === 0) {
    return "withdraw";
  }

  let decided = null;
  if (row.approvalLevel === 1 && row.isManagerLV1Approve !== null) {
    decided = row.isManagerLV1Approve;
  } else if (row.approvalLevel === 2 && row.isManagerLV2Approve !== null) {
    decided = row.isManagerLV2Approve;
  } else {
    return null;
  }

  return decided === 1 ? "approved" : decided === 0 ? "notApproved" : null;
};

export const classifyLeaveStatus = (row) => {
  if (row.idLeaveEmployeesWithdraw) {
    return "withdraw";
  }
  if (row.isActive === 0) {
    return "withdraw";
  }
  if (row.isApprove === 1) {
    return "approved";
  }
  if (row.isApprove === 0) {
    return "notApproved";
  }
  return null;
};
